import {Switch as ArkSwitch} from '@ark-ui/react/switch'
import './index.less'

export const SwitchControl = () => {
	return (
		<ArkSwitch.Control>
			<ArkSwitch.Thumb />
		</ArkSwitch.Control>
	)
}
